<div #blockSettingsWrapper>
  <div id="blockDataSettings">
    <div #blockDataSettings></div>
  </div>
  <div id="blockStyleSettings">
    <div #blockStyleSettings></div>
  </div>
</div>
